import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CautionStatusBadge: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text
}) => {
    const { CAUTION } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.cautionStatusBadge}`}
            testId={testId}
            text={text ?? CAUTION}
        />
    );
};

export default CautionStatusBadge;
